import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiNdmsModule } from '../../../../shared/ui-ndms/ui-ndms.module';
import { UiRmsModule } from '../../../../rms/app/shared/ui-rms/ui-rms.module';
import { HirNavComponent } from "../../components/hir-nav/hir-nav.component";
import { HirHomeComponent } from "../../components/home/home.component";
import { HirProgramCardComponent } from '../../components/program-card/hir-program-card.component';
import { HasPermissionDirective } from '../core-hir/has-permission.directive';

@NgModule({
  imports: [
    CommonModule,
    UiNdmsModule,
    UiRmsModule
  ],
  declarations: [
    HirNavComponent,
    HirHomeComponent,
    HirProgramCardComponent,
    HasPermissionDirective
  ],
  exports: [
    UiNdmsModule,
    UiRmsModule,
    HirNavComponent
  ],
  entryComponents: [
  ]
})
export class UiHirModule { }
